import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=59ccfb20&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=59ccfb20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ccfb20",
  null
  
)

export default component.exports